import React, {useState, useContext} from "react";
import { useNavigate } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { getImages } from '../Common/const'
import ValidationError from "../Errors/ValidationError";
import { UserContext } from "../Context/UserContext";
const validationSchema = Yup.object({
    username: Yup.string().required("Username is required"),
    password: Yup.string().required("Password is required"),
    agree: Yup.boolean().oneOf([true], "You must accept the terms")
});

const Login = () => {
    const [formikData, setFormikData] = useState({
        signin_username: "",
        signin_password: ""
    });

    const navigate = useNavigate();

    const {loginUser, wait, loggedInCheck, forgotPassword, registrationForm, addUser} = useContext(UserContext);
    const [redirect, setRedirect] = useState(false);
    const [errMsg, setErrMsg] = useState(false);
    const [formData, setFormData] = useState({
        signin_username:'',
        signin_password:'',
        terms:true
    });

    const onChangeInput = (e) => {
        setFormData({
            ...formData,
            [e.target.name]:e.target.name == "terms" ? e.target.checked : e.target.value
        })
    }

    const submitForm = async (e) => {
        e.preventDefault();

        if(!formData.terms){
            setErrMsg('Please accept terms & conditions');
            return;
        }

        if(formData.signin_username.trim() === '' || formData.signin_password.trim() === ''){
            setErrMsg('Please Fill in all Required Fields!');
            return;
        }

        const data = await loginUser(formData);
        if(data.success){
            e.target.reset();
            setRedirect('Signing in...');
            await loggedInCheck();
            navigate("/update-equipment");
            return;
        }
        setErrMsg(data.message);
    }

    return (
        <>
            <div className='login-header'>
                <img src={getImages('mm-logo-white.svg')} />
            </div>
            <div className="login-page-block position-relative">
                <div className='login-box'>
                    <div className='md-title text-uppercase text-center font-1-5em'>Login</div>
                    <form className="login-form custom-form" onSubmit={submitForm} method="post">
                        <div className="form-group">
                            <div className="cs-label mb-2">Username</div>
                            <input type='text' name="signin_username" className='form-control' onChange={onChangeInput}/>
                        </div>

                        <div className="form-group">
                            <div className="cs-label mb-2">Password</div>
                            <input type='password' name="signin_password" className='form-control' onChange={onChangeInput}/>
                        </div>

                        <div className="form-group checkbox-wrapper">
                            {/* <label className="custom-checkbox">
                                <Field type="checkbox" name="agree" />
                                <span className="checkmark"></span>
                                I agree to the terms
                            </label> */}
                            <div className="custom-checkbox ss-checkbox">
                                <input
                                    type="checkbox"
                                    name="agree"
                                    id='rememberMe'
                                />
                                <label htmlFor="rememberMe" className='w-100'>Remember Me</label>
                            </div>
                        </div>

                        <button type="submit" className="btn-admin sm-btn w-100">Login</button>
                        <div className="mt-5">
                            <a href="#" className="cs-label fw-500">Forgot your password?</a>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default Login